import React from 'react';
import styled from '@emotion/styled';
import theme from '~/theme';
import { dynamicFontSize } from '~/utilities/helpers';
import { transition } from '~/styles/transition';
import PropTypes from 'prop-types';

const variantCss = (shape, color) => {
    let styles = `
        border: 3px solid ${theme.colors.text[color]};
        color: ${theme.colors.text[color]};    
    `;

    if (shape === 'pill') {
        styles += `border-radius: 100px;`;
    }

    return styles;
};

const Button = styled.button`
    display: block;
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${dynamicFontSize(1.7, 1.8, 2.1)};
    padding: 2rem;
    background-color: transparent;
    cursor: pointer;

    text-decoration: none;
    letter-spacing: 0.075rem;
    text-align: center;
    white-space: nowrap;
    line-height: 1;

    min-width: 170px;

    ${({ shape, color }) => variantCss(shape, color)};

    ${transition({}, 'color', 'border-color', 'box-shadow')};

    @media (max-width: ${theme.breakpoint.largePhoneMax}) {
        padding: 1.5rem;
    }

    &:disabled {
        pointer-events: none;
        cursor: auto;
    }

    &:not(:disabled):hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    }
`;

const OutlineButton = ({
    color = 'black',
    shape = 'rectangle',
    children,
    ...rest
}) => {
    return (
        <Button {...{ color, shape }} {...rest}>
            {children}
        </Button>
    );
};

OutlineButton.propTypes = {
    color: PropTypes.oneOf(Object.keys(theme.colors.text)),
    shape: PropTypes.oneOf(['rectangle', 'pill'])
};

export default OutlineButton;
